import { Modal, Form, Input, Button, Row, Col, message } from 'antd';
import React, { useState, useContext } from 'react';
import { axiosPostCall } from '../../api/axiosCall';
import { AuthContext } from '../../context/AuthProvider';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../../constant/constants';

const AddAddressModal = ({ isOpen, onClose, onAddressAdded, companyId }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);

      const addressData = {
        companyId: companyId,
        mobileNo: values.mobileNo,
        streetAddress: values.streetAddress,
        city: values.city,
        state: values.state,
        country: values.country,
        zipCode: values.zipCode,
        transporterName: values.transporterName,
      };

      const res = await axiosPostCall({
        apiEndPoint: API_END_POINT.ADD_ADDRESS,
        header: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: addressData,
      });

      if (res?.hideErrorFromUser && res?.data) {
        const newAddress = {
          value: res.data.addressId || Date.now(),
          label: `${values.streetAddress}, ${values.city}, ${values.state} ${values.zipCode}`,
          addressData: res.data,
        };
        onAddressAdded(newAddress);
        message.success('Address added successfully!');
        form.resetFields();
      } else {
        message.error(res?.error?.message || SOMETHING_WENT_WRONG);
      }
    } catch (error) {
      console.error('Error adding address:', error);
      message.error(SOMETHING_WENT_WRONG);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title='Add New Address'
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout='vertical'
        onFinish={handleSubmit}
        autoComplete='off'
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name='mobileNo'
              label='Mobile Number'
              rules={[
                { required: true, message: 'Please enter mobile number' },
                {
                  pattern: /^[0-9]{10}$/,
                  message: 'Please enter a valid 10-digit mobile number',
                },
              ]}
            >
              <Input
                placeholder='Enter mobile number'
                maxLength={10}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name='transporterName'
              label='Transporter Name'
              rules={[
                { required: true, message: 'Please enter transporter name' },
              ]}
            >
              <Input placeholder='Enter transporter name' />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name='streetAddress'
              label='Street Address'
              rules={[
                { required: true, message: 'Please enter street address' },
              ]}
            >
              <Input placeholder='Enter street address' />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name='city'
              label='City'
              rules={[{ required: true, message: 'Please enter city' }]}
            >
              <Input placeholder='Enter city' />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='state'
              label='State'
              rules={[{ required: true, message: 'Please enter state' }]}
            >
              <Input placeholder='Enter state' />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name='country'
              label='Country'
              rules={[{ required: true, message: 'Please enter country' }]}
            >
              <Input placeholder='Enter country' />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name='zipCode'
              label='Zip Code'
              rules={[
                { required: true, message: 'Please enter zip code' },
                {
                  pattern: /^[0-9]{6}$/,
                  message: 'Please enter a valid 6-digit zip code',
                },
              ]}
            >
              <Input
                placeholder='Enter zip code'
                maxLength={6}
              />
            </Form.Item>
          </Col>
        </Row>

        <div className='flex justify-end space-x-2 mt-6'>
          <Button
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            type='primary'
            htmlType='submit'
            loading={isLoading}
          >
            Add Address
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddAddressModal;
